import { render, staticRenderFns } from "./PersonalInformationPage.vue?vue&type=template&id=2e41c0df&scoped=true"
import script from "./PersonalInformationPage.vue?vue&type=script&lang=js"
export * from "./PersonalInformationPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalInformationPage.vue?vue&type=style&index=0&id=2e41c0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41c0df",
  null
  
)

export default component.exports